
import React from "react";
import { Helmet } from "react-helmet-async";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { BarChart, Users, Settings, Calendar, Mail, Bell, Shield } from "lucide-react";
import { Link } from "react-router-dom";
import AdminMetricsOverview from "@/components/admin/AdminMetricsOverview";
import AdminOperatorsList from "@/components/admin/AdminOperatorsList";
import AdminActivationStats from "@/components/admin/AdminActivationStats";

const AdminLanding: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Admin Dashboard | SaunaDip</title>
        <meta name="description" content="Admin dashboard for SaunaDip operator management" />
      </Helmet>
      
      <div className="bg-white">
        {/* Admin Header */}
        <header className="bg-sauna-navy border-b shadow-sm sticky top-0 z-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16 items-center">
              <div className="flex items-center">
                <Link to="/admin-landing" className="flex-shrink-0 text-white font-bold text-xl">
                  SaunaDip Admin
                </Link>
              </div>
              <nav className="flex items-center space-x-4">
                <Button variant="ghost" size="sm" className="text-white hover:text-sauna-beige">
                  <Shield className="h-5 w-5 mr-1" />
                  <span>Admin</span>
                </Button>
                <Button variant="ghost" size="sm" className="text-white hover:text-sauna-beige">
                  <Settings className="h-5 w-5 mr-1" />
                  <span>Settings</span>
                </Button>
                <Link to="/" className="text-white hover:text-sauna-beige text-sm">
                  View Site
                </Link>
              </nav>
            </div>
          </div>
        </header>

        {/* Admin Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col space-y-6">
            {/* Admin Title */}
            <div>
              <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">Admin Dashboard</h1>
              <p className="mt-1 text-sm text-gray-600">
                Manage operators and monitor directory performance metrics
              </p>
            </div>

            {/* Stats Overview */}
            <AdminMetricsOverview />

            {/* Recent Activations */}
            <AdminActivationStats />
            
            {/* Operators Management */}
            <AdminOperatorsList />
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLanding;
